import { useEffect, useState } from 'react';

/** tailwind `cubic-bezier(0.22, 1, 0.36, 1)` 과 거의 같은 감속 곡선(ease-out quint). */
const easeOutQuint = (t: number) => 1 - (1 - t) ** 5;

/**
 * 막대가 차는 동안 정답률 숫자를 0 → target 으로 올린다.
 * 움직임 줄이기 설정이면 처음부터 target 을 보여 준다.
 */
export function useCountUp(
  target: number,
  delayMs: number,
  durationMs: number,
) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setValue(target);
      return;
    }
    const startAt = performance.now() + delayMs;
    let frame = requestAnimationFrame(function tick(now) {
      const progress = Math.min(1, Math.max(0, (now - startAt) / durationMs));
      setValue(Math.round(target * easeOutQuint(progress)));
      if (progress < 1) frame = requestAnimationFrame(tick);
    });
    return () => cancelAnimationFrame(frame);
  }, [delayMs, durationMs, target]);

  return value;
}
